module.exports = __webpack_public_path__ + "img/banner.bbad63cd.png";